import { Edit, ExpandMore } from '@mui/icons-material';
// Components
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormLabel,
  IconButton,
  Typography
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import React, { FC } from 'react';
import { ExternalLink } from '../../../../components/link/ExternalLink';
// Types
import { IMissingDocumentTemplate } from '../../../../models';

interface IMobileMissingContractTemplates {
  original: IMissingDocumentTemplate;
  handleEdit?: (val: IMissingDocumentTemplate) => void;
  handleDelete?: (val: IMissingDocumentTemplate) => void;
}

export const MobileMissingContractTemplates: FC<IMobileMissingContractTemplates> = ({
  original,
  handleEdit,
  handleDelete
}) => {
  const classes = useStyles();
  const { name, id } = original;

  return (
    <Accordion className={classes.root}>
      <AccordionSummary
        className={classes.accordion}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.topPanelSummaryWrapper}>
          <Typography variant="body2">{name}</Typography>
          <div className={classes.buttonsWrapper}>
            <ExternalLink target={'_blank'} to={`https://app.pandadoc.com/a/#/templates/${id}`}>
              <IconButton className={classes.editButton} color="primary" size="large">
                <Edit />
              </IconButton>
            </ExternalLink>
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Name:
          </FormLabel>
          <Typography component="span" variant="body2">
            {name || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Id:
          </FormLabel>
          <Typography component="span" variant="body2">
            {id || '--'}
          </Typography>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  },
  editButton: {
    padding: `2px 5px`
  },
  deleteButton: {
    padding: `2px 5px`,
    color: theme.palette.error.main
  },
  boldName: {
    color: theme.palette.typography.labels,
    fontWeight: 600
  },
  subLabel: {
    marginRight: 10,
    fontSize: theme.typography.body2.fontSize
  },
  buttonsWrapper: {
    display: 'flex'
  }
}));
